// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"c8656d2d","545":"482ef1f2","787":"cda612ba"}[chunkId] + ".chunk.js";
};